import { useContext } from 'react'
import {
  FunctionalDiagramEditContext,
  RESET_SELECTED_CONNECTORS,
  SELECT_DESELECT_CONNECTORS,
  SET_CONNECTOR_TAB,
  SET_FUNCTIONAL_DIAGRAM_DETAILS,
} from './context/context'
import SelectConnectorItem from './SelectConnectorItem'
import NoDataFound from '../../../common/NoDataFound'
import Button from '../../../common/Button'
import { postRequest } from '../../../../services/base'
import { decrypt } from '../../../../utils/encryption'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../../../context/global_context'
import CategoryFilter from './CategoryFilter'

const SelectConnectSection = (props) => {
  const { functional, vehicle } = useParams()
  const [navState, navDispatch] = useContext(NavContext)
  const [state, dispatch] = useContext(FunctionalDiagramEditContext)

  const saveMapping = async (action) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `${action === 'create' ? 'Saving' : 'Deleting'} Connector Mappig Details`,
        showLoader: true,
      },
      notification: {},
    })
    const formData = new FormData()
    formData.append('vehicle', vehicle)
    formData.append('action', action)

    state?.selectedConnectors?.forEach((row, index) => {
      formData.append('connector', row)
    })

    state?.selectedCircuitPins?.forEach((row, index) => {
      formData.append('start_connector', row.split('**$$')[2])
    })

    let res = await postRequest(
      `/api/sub_system/functional-diagram/connector/${decrypt(functional)}/?vehicle=${vehicle}`,
      formData
    )

    dispatch({
      type: SET_FUNCTIONAL_DIAGRAM_DETAILS,
      data: {
        ...state.functionalDiagramDetails,
        sales_code_data: res.sales_code,
      },
      mappedConnector: res.data,
      connectorCategories: res.category,
    })

    navDispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: `Connectors ${action === 'create' ? 'Mapped' : 'Deleted'} Successfully!`,
      },
    })
  }

  const pendingFilteredConnectors = state?.selectConnectors?.pending
    .map((pending) => {
      const changedObj = state?.selectConnectors?.mapped.find(
        (mapped) => mapped.connector_data_id === pending.id
      )
      return changedObj ? { ...pending, isMapped: true } : pending
    })
    .filter((pending) =>
      state?.selectedConnectorCategories?.length > 0
        ? state?.selectedConnectorCategories.find(
            (category) => category === pending.category
          )
        : []
    )

  return (
    <>
      <div className="flex justify-between text-sm pt-2 px-2">
        <div className="flex">
          <div
            className={`py-1 px-3 ${state?.selectConnectors?.current === 'pending' ? 'bg-white' : 'bg-tracer-lt-blue text-white'} cursor-pointer flex text-base font-medium items-center`}
            onClick={() => {
              dispatch({ type: SET_CONNECTOR_TAB, data: 'pending' })
            }}
          >
            Pending{' '}
            {state?.selectConnectors?.current === 'pending' && (
              <span className="">&#x25B2;</span>
            )}
          </div>
          <div
            className={`py-1 px-3 ${state?.selectConnectors?.current === 'mapped' ? 'bg-white' : 'bg-tracer-lt-blue text-white'} cursor-pointer flex text-base font-medium items-center`}
            onClick={() => {
              dispatch({ type: SET_CONNECTOR_TAB, data: 'mapped' })
            }}
          >
            Mapped{' '}
            {state?.selectConnectors?.current === 'mapped' && (
              <span className="">&#x25B2;</span>
            )}
          </div>
        </div>
        {state?.selectConnectors?.current === 'pending' && <CategoryFilter />}
      </div>

      <div
        className="px-2 rounded"
        style={{ height: '60vh', overflowY: 'scroll' }}
      >
        {state?.selectConnectors?.current === 'pending' ? (
          pendingFilteredConnectors?.length > 0 ? (
            pendingFilteredConnectors?.map((connector, connectorIndex) => {
              return (
                <div
                  key={`connector-pending-${connector.id}-${connectorIndex}`}
                >
                  <SelectConnectorItem
                    {...connector}
                    key={`pending-connector-row-${connectorIndex}`}
                    onConnectorSelect={() => {
                      dispatch({
                        type: SELECT_DESELECT_CONNECTORS,
                        data: connector.id,
                      })
                    }}
                    selectedConnectors={state.selectedConnectors}
                    value={state.selectedConnectors?.includes(connector.id)}
                  />
                </div>
              )
            })
          ) : (
            <NoDataFound />
          )
        ) : (
          ''
        )}
        {state?.selectConnectors?.current === 'mapped' ? (
          state?.selectConnectors?.mapped?.length > 0 ? (
            state?.selectConnectors?.mapped?.map(
              (connector, connectorIndex) => {
                return (
                  <div
                    key={`connector-mapped-${connector.id}-${connectorIndex}`}
                  >
                    <SelectConnectorItem
                      {...connector}
                      key={`mapped-connector-row-${connectorIndex}`}
                      onConnectorSelect={() => {
                        dispatch({
                          type: SELECT_DESELECT_CONNECTORS,
                          data: connector.connector_data_id,
                        })
                      }}
                      selectedConnectors={state.selectedConnectors}
                      value={state.selectedConnectors?.includes(
                        connector.connector_data_id
                      )}
                    />
                  </div>
                )
              }
            )
          ) : (
            <NoDataFound />
          )
        ) : (
          ''
        )}
      </div>

      {state.selectedConnectors?.length > 0 ? (
        <>
          {state?.selectConnectors?.current === 'pending'
            ? state?.selectConnectors?.pending?.length > 0 && (
                <div className="flex items-center text-white text-center font-medium justify-center py-6 px-2 gap-2">
                  <Button
                    type="submit"
                    className={`cursor-pointer btn w-full`}
                    onClick={(e) => {
                      saveMapping('create')
                    }}
                    value={'text'}
                    text="Save Mapping"
                  />
                  <Button
                    type="submit"
                    className={`cursor-pointer btn w-full`}
                    onClick={(e) => {
                      dispatch({ type: RESET_SELECTED_CONNECTORS, data: [] })
                    }}
                    value={'text'}
                    text="Clear Selection"
                  />
                </div>
              )
            : state?.selectConnectors?.mapped?.length > 0 && (
                <div className="flex items-center text-white text-center font-medium justify-center py-6 px-2 gap-2">
                  <Button
                    type="submit"
                    className={`cursor-pointer btn w-full`}
                    onClick={(e) => {
                      saveMapping('delete')
                    }}
                    value={'text'}
                    text="Delete Selected"
                  />
                  <Button
                    type="submit"
                    className={`cursor-pointer btn w-full`}
                    onClick={(e) => {
                      dispatch({ type: RESET_SELECTED_CONNECTORS, data: [] })
                    }}
                    value={'text'}
                    text="Clear Selection"
                  />
                </div>
              )}
        </>
      ) : (
        state?.selectedCircuitPins?.length > 0 && (
          <div className="flex items-center text-white text-center font-medium justify-center py-6 px-2 gap-2">
            <Button
              type="submit"
              className={`cursor-pointer btn w-full`}
              onClick={(e) => {
                saveMapping('create')
              }}
              value={'text'}
              text="Save Start Connectors"
            />
          </div>
        )
      )}
    </>
  )
}

export default SelectConnectSection
